import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import styles from './MatchOption.module.scss';

export interface MatchOptionProps {
  text: string;
  pairNumber?: number;
  disabled?: boolean;
  isCorrect?: boolean;
  selected?: boolean;
  onClick(): void;
}

function MatchOption({
  text,
  pairNumber,
  onClick,
  disabled,
  selected,
  isCorrect,
}: MatchOptionProps) {
  const customColors = ['#F7BB49', '#2FAC66', '#E94B56', '#AB96DE', '#50BCB8'];
  const selectedColor = pairNumber
    ? customColors[pairNumber - 1]
    : 'transparent';

  return (
    <button
      type="button"
      data-testid="match-option"
      onClick={disabled ? undefined : onClick}
      style={{'--color': selectedColor} as React.CSSProperties}
      className={`
        ${styles.button} 
        ${pairNumber ? styles.paired : ''}
        ${selected ? styles.selected : ''} `}
    >
      <div className={styles.content}>
        <span className={styles.pairMarker}>{pairNumber}</span>

        {text}
      </div>

      {isCorrect !== undefined && (
        <FontAwesomeIcon
          data-testid="match-option-icon"
          className={styles.icon}
          color={isCorrect ? 'green' : 'red'}
          icon={isCorrect ? 'check' : 'xmark'}
        />
      )}
    </button>
  );
}

export default MatchOption;
